export function formatarCep(cep: string | undefined | null): string {
  if (!cep) return 'N/A';
  
  const numeros = cep.replace(/\D/g, '');
  
  if (numeros.length !== 8) {
    return cep;
  }
  
  return `${numeros.slice(0, 5)}-${numeros.slice(5)}`;
}
